import React, { useState, useEffect, useContext } from "react";
import { dimColor } from "../../functions/utils";
import "./Button.css";
import { ConfigContext } from "../../App";
import textConfig from "../../configuration.json";
import { TranslateContext } from "../../App";

/**
 * Submit button component for checkout form.
 * @param {Object} props - Component props.
 * @param {string} props.type - Button size type ('small', 'medium', 'large').
 * @param {Function} props.onClick - Click handler function.
 * @param {boolean} props.isLoading - Whether the button is in loading state.
 * @param {boolean} props.disabled - Whether the button is disabled.
 */
function SubmitButton({ type, onClick, isLoading = false, disabled = false }) {
  const configuration = useContext(ConfigContext);
  const [hovered, setHovered] = useState(false);
  const [buttonClass, setButtonClass] = useState("");
  const [buttonClassInner, setButtonClassInner] = useState("");
  const language = useContext(TranslateContext).language;

  const isDisabled = isLoading || disabled;

  useEffect(() => {
    if (type === "small") {
      setButtonClass("button-sm");
      setButtonClassInner("button-sm-inner");
    } else if (type === "medium") {
      setButtonClass("button-md");
      setButtonClassInner("button-md-inner");
    } else if (type === "large") {
      setButtonClass("button-lg");
      setButtonClassInner("button-lg-inner");
    } else {
      setButtonClass("button-md");
      setButtonClassInner("button-md-inner");
    }
  }, [configuration, type]);

  function handleHover(state) {
    if (!isDisabled) {
      setHovered(state);
    }
  }

  return (
    <div
      className={buttonClass}
      style={{
        backgroundColor: hovered ? dimColor(configuration.colors?.main?.hex, 20) : configuration.colors?.main?.hex,
        opacity: isDisabled ? 0.6 : 1,
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
      onMouseEnter={() => handleHover(true)}
      onMouseLeave={() => handleHover(false)}
    >
      <button className={buttonClassInner} onClick={isDisabled ? undefined : onClick} disabled={isDisabled}>
        {isLoading ? textConfig.texts.processing?.[language] || "Обработка..." : textConfig.texts.submitOrder[language]}
      </button>
    </div>
  );
}

export default SubmitButton;
